import { render, staticRenderFns } from "./levelFivepage.vue?vue&type=template&id=3fa51720&scoped=true&"
import script from "./levelFivepage.vue?vue&type=script&lang=js&"
export * from "./levelFivepage.vue?vue&type=script&lang=js&"
import style0 from "./levelFivepage.vue?vue&type=style&index=0&id=3fa51720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa51720",
  null
  
)

export default component.exports